export default __webpack_public_path__ + "static/media/gift-card-cart-icon.81e3618c.svg";